import { useMemo } from 'react'

const useSearchResultsPagination = (searchResults, resultsPerPage = 8, currentPage = 1) => {
  const paginationData = useMemo(() => {
    const totalPages = Math.ceil(searchResults?.length / resultsPerPage)
    const paginatedResults =
      searchResults?.length > 0
        ? searchResults.slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage)
        : []

    return {
      totalPages,
      paginatedResults,
      hasResults: searchResults.length > 0,
      hasPagination: totalPages > 1,
    }
  }, [searchResults, resultsPerPage, currentPage])

  return paginationData
}

export default useSearchResultsPagination
